const PHRASES = [
  "WHERE REAL LIFE BECOMES A STORY WORTH REPLAYING",
  "REAL-LIFE VIDEO EDITING",
  "SEND THE FOOTAGE — KEEP THE MEMORY",
  "JW. EDITS — EST. 2026",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {PHRASES.map((p) => (
      <span key={p} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-wide text-[#3a3a3f] sm:text-3xl">
          {p}
        </span>
        <span className="h-1.5 w-1.5 shrink-0 bg-[#E63946]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-white/10 bg-[#050505] py-5"
  >
    <div className="animate-marquee flex w-max">
      <Strip />
      <Strip />
    </div>
  </div>
);
